<script lang="ts">
	import Actito from '$lib/components/third-parties/actito/Actito.svelte';
	import Awin from '$lib/components/third-parties/awin/Awin.svelte';
	import Criteo from '$lib/components/third-parties/criteo/Criteo.svelte';
	import DatadogRum from '$lib/components/third-parties/datadog/DatadogRum.svelte';
	import GoogleAds from '$lib/components/third-parties/google/ads/GoogleAds.svelte';
	import GoogleAnalytics from '$lib/components/third-parties/google/analytics/GoogleAnalytics.svelte';
	import IABConsent from '$lib/components/third-parties/IABConsent.svelte';
	import Kwanko from '$lib/components/third-parties/kwanko/Kwanko.svelte';
	import MetaPixel from '$lib/components/third-parties/meta-ads/MetaPixel.svelte';
	import BrowserNewRelic from '$lib/components/third-parties/newrelic/BrowserNewRelic.svelte';
	import Pinterest from '$lib/components/third-parties/pinterest/Pinterest.svelte';
	import Runnea from '$lib/components/third-parties/runnea/Runnea.svelte';
	import TikTokAds from '$lib/components/third-parties/tiktok-ads/TikTokAds.svelte';

	const { sfbxAppKey, thirdParties }: { sfbxAppKey: string; thirdParties?: ThirdParties } =
		$props();
</script>

<IABConsent {sfbxAppKey} />
<GoogleAds gadsId={thirdParties?.google_ads?.id} />
<GoogleAnalytics gaId={thirdParties?.google_analytics?.id} />
<Awin awinId={thirdParties?.awin?.id} />
<MetaPixel pixelId={thirdParties?.meta_pixel?.id} />
<TikTokAds merchantId={thirdParties?.tiktok_ads?.merchant_id} />
<Kwanko unijsLink={thirdParties?.kwanko?.unijs_link} />
<Criteo accountId={thirdParties?.criteo?.account_id} />
<Runnea accountId={thirdParties?.runnea?.account_id} />
<Pinterest tagId={thirdParties?.pinterest?.tag_id} />
<Actito goalUri={thirdParties?.actito?.goal_uri} />
<BrowserNewRelic />
<DatadogRum />
